import React from "react";

import { selectLabel } from "../../pages/GdkMiddlewareRequestPage/gdkMiddlewarePageContent";
import { SelectDropdown } from "../SelectDropdown";
import * as styles from "./GdkMiddlewareDropdown.module.css";

export type GdkMiddlewareDropdownOption = Readonly<{
  id: string;
  label: string;
}>;

export type GdkMiddlewareDropdownProps = Readonly<{
  currentValue: string;
  onChange?: (id: string) => void;
  options: GdkMiddlewareDropdownOption[];
  disabled?: boolean;
}>;

export const GdkMiddlewareDropdown = ({
  currentValue,
  onChange,
  options,
  disabled,
}: GdkMiddlewareDropdownProps) => {
  const handleChange = (id: string) => {
    if (id && onChange) {
      onChange(id);
    }
  };

  return (
    <SelectDropdown
      className={styles.customSelect}
      options={options}
      value={currentValue}
      onChange={handleChange}
      placeholder={selectLabel}
      disabled={disabled}
    />
  );
};
